import React from 'react';

const FaqForEmployers = () => {
  return <div>Работодатели</div>;
};

export default FaqForEmployers;
